// extracted by mini-css-extract-plugin
module.exports = {"landing_content":"_landing_landing_content__2lKuO","item":"_landing_item__2asHE","icon":"_landing_icon__12t4I","landing_infotext":"_landing_landing_infotext__cW34e"};